import React from "react";
import { CheckIcon } from "lucide-react";
import { diagnosisChecklist } from "../data/landing";
import { MobileAccordion } from "./MobileAccordion";
import { Reveal, STAGGER } from "./Reveal";
import { SectionHeader } from "./SectionHeader";
function CheckBox() {
  return <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-[3px] border border-gold/60" data-id="element-138" data-mp="xsczcwu1xllm">
      <CheckIcon className="h-3.5 w-3.5 text-gold" strokeWidth={3} aria-hidden="true" data-id="element-139" data-mp="1lhe0dz0k1ugv" />
    </span>;
}
export function DiagnosisChecklist() {
  return <section aria-labelledby="diagnostico" className="section-pad border-b border-line" data-id="element-140" data-mp="1qj3b1djv864f">
      <div className="page-container grid gap-8 md:gap-12 lg:grid-cols-12 lg:gap-8" data-id="element-141" data-mp="1bruf6mpddoiu">
        <Reveal className="lg:col-span-5" data-id="element-142" data-mp="1gpmi0brjyv1t">
          <SectionHeader number="09" label="El diagnóstico" titleId="diagnostico" title="Qué revisamos en el diagnóstico" data-id="element-143" data-mp="24grz0u98btdp" />
          <p className="mt-6 max-w-[62ch] font-ui text-[17px] font-bold leading-snug text-cream md:text-[18px]" data-id="element-144" data-mp="299kyp3pucbix">
            Si podemos ayudarte, te explicamos cómo.{" "}
            <span className="text-muted" data-id="element-145" data-mp="1pogqt73iicxd">Si no, te decimos qué ajustar primero.</span>
          </p>
        </Reveal>

        <MobileAccordion defaultOpen={null} items={[{
        id: "checklist",
        title: "Ver los 6 puntos",
        content: <ul className="space-y-3" data-id="element-147" data-mp="2dan70gn3ayyo">
                  {diagnosisChecklist.map(item => <li key={item} className="flex items-start gap-3" data-id="element-148" data-mp="28d57fguypw3c">
                      <CheckBox data-id="element-149" data-mp="2n9mjybew1grh" />
                      <span className="text-[16px] leading-snug text-cream" data-id="element-150" data-mp="2n9w77r8jt9th">{item}</span>
                    </li>)}
                </ul>
      }]} data-id="element-146" data-mp="24d4l7a1mgglq" />

        <ul className="hidden border-t border-line md:block lg:col-span-6 lg:col-start-7" data-id="element-151" data-mp="syqyw9mio97t">
          {diagnosisChecklist.map((item, i) => <li key={item} className="border-b border-line" data-id="element-152" data-mp="1dm78ck7y1wu8" data-mpi={i}>
              <Reveal delay={i * STAGGER} className="flex items-start gap-4 py-5" data-id="element-153" data-mp="1dns2w9u9dfs3">
                <CheckBox data-id="element-154" data-mp="1hnkg4zulka3s" />
                <span className="text-[17px] text-cream" data-id="element-155" data-mp="1mmdjw0k30mqr">{item}</span>
              </Reveal>
            </li>)}
        </ul>
      </div>
    </section>;
}